$('body').on('click', '.js-scroll-to-element', function (e) {
    const target = $(e.target).closest('.js-scroll-to-element')
    const anchor = $(target.attr('data-anchor'))

    if (anchor.length) {
        anchor[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        })
    }
})
